<!--
 * @Description: 调代课申请 列表页
 * @Author: ZSC
 * @Date: 2023-03-08 14:26:07.83
 * @LastEditors: PF
 * @LastEditTime: 2024-03-19 17:21:57
-->
<template>
  <div>
    <el-dialog class="w1000 h700" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">调代课</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

              <el-form-item>
                <el-select placeholder="状态" v-model="dataGrid.parms.zt" clearable filterable @change="bindTable()">
                  <el-option v-for="(item, index) in tdkztData.list" :key="index" :label="item.name" :value="item.value"/>
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button class="w200" type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="申请时间" prop="sqsj" width="160" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
              <el-table-column label="调代课时间段" prop="kssj" width="260" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  {{ scope.row.kssj }} - {{ scope.row.jssj }}
                </template>
              </el-table-column>
              <el-table-column label="原因" prop="yy" align="center" show-overflow-tooltip />
              <el-table-column label="类型" prop="lx" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-for="(item, index) in tdklxData.list" :key="index">
                    <span v-if="scope.row.tdklx === item.value">{{ item.name }}</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="状态" prop="zt" width="100" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                <template #default="scope">
                  <span v-for="(item, index) in tdkztData.list" :key="index">
                    <span v-if="scope.row.zt === item.value">{{ item.name }}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="205" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" v-if="scope.row.zt === tdkztData.yiluru" @click="tiJiaoClick(scope.row)">提交</el-button>
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
        </el-container>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          <div class="footer_but">
            <el-button @click="openList=false;homeCloseWindow('openReturn', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import { loadList, submitDataGridAction, homeCloseWindow, actionPost, loadSelect } from '@/api/common.js'
import { successPrompt, warningPrompt } from '@/utils/promptInfo.js'
import { gettdkzt } from '@/utils/meiju'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 提交
const tiJiaoClick = (item) => {
  const o = { url: '/api/v2/jiaowu/tiaodaikeshenqing/tijiao', data: { id: item.id } }
  dataGrid.value.loading = true // 开始加载
  actionPost(o).then((res) => {
    dataGrid.value.loading = false // 结束加载
    if (res.code === 200) {
      bindTable()
      emits('ReturnData')
      successPrompt(res.message)
    } else {
      warningPrompt(res.message)
    }
  })
}
// 加载 调代课状态 下拉框
const tdkztData = ref({ list: [] })
// 加载 调代课类型 下拉框
const tdklxData = ref({ list: [] })
const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'sqsj', order: 'descending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const bindTable = async (pageNo, pageSize) => {
  dataGrid.value.parms.zt = dataGrid.value.parms.zt === '' ? undefined : dataGrid.value.parms.zt
  loadList({
    url: '/api/v2/jiaowu/tiaodaikeshenqing/wode',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
      dataGrid.value.pagination.pagerCount = 5
      dataGrid.value.pagination.layout = 'prev, pager, next, total'
    }
  })
}
bindTable()

// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/jiaowu/tiaodaikeshenqing',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function (res) {
      bindTable()
    }
  })
}
watch(
  () => props.open,
  () => {
    if (props.open === 'tiaodaike') {
      openList.value = true
      tdkztData.value = gettdkzt()
      loadSelect({ url: '/api/v2/jiaowu/tiaodaikeshenqing/tiaodaikeleixing', data: tdklxData })
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>
